import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initCustomSortBy from '../sections/collection/initCustomSortBy';
import initLoadMore from '../components/load-more';
import initCollectionDescription from '../components/collection-description';
import initFacetViewMore from '../sections/collection/initFacetViewMore';
import { syncAllExpandedFacetScrollSurfaces } from '../utils/facetScrollStyles';

ready(() => {
  initCollectionSearchFilters();
  initCustomSortBy();
  initLoadMore();
  initCollectionDescription();
  initFacetViewMore();
  syncAllExpandedFacetScrollSurfaces();
});

onShopifySectionLoad(() => {
  initCollectionSearchFilters();
  initCustomSortBy();
  initLoadMore();
  initCollectionDescription();
  initFacetViewMore();
  syncAllExpandedFacetScrollSurfaces();
});
